import { FormGroup, FormSection, TextInput } from '@ksyos/design-system';
import { getSelectedLanguage } from '@frontend/translate';
import { useFormContext } from '@frontend/utils/hooks/useFormContext';
import type { OrderSuppliesFormState } from '../../types/orderSuppliesFormState';

export function OrderSuppliesPersonalData() {
    const translate = getSelectedLanguage();
    const form = useFormContext<OrderSuppliesFormState>();

    return (
        <FormSection title={translate.common.personalData}>
            <FormGroup label={translate.common.nameGiven}>
                <TextInput
                    disabled={form.isSubmitting}
                    error={form.errors.getMessage('personal.nameGiven')}
                    name="personal.nameGiven"
                    onBlur={form.handleBlur}
                    onChange={form.handleChange}
                    value={form.values.personal.nameGiven ?? ''}
                />
            </FormGroup>
            <FormGroup label={translate.common.nameInfix2}>
                <TextInput
                    disabled={form.isSubmitting}
                    error={form.errors.getMessage('personal.nameInfix')}
                    name="personal.nameInfix"
                    onBlur={form.handleBlur}
                    onChange={form.handleChange}
                    value={form.values.personal.nameInfix ?? ''}
                />
            </FormGroup>
            <FormGroup
                isRequired={true}
                label={translate.common.nameFamily}
            >
                <TextInput
                    disabled={form.isSubmitting}
                    error={form.errors.getMessage('personal.nameFamily')}
                    name="personal.nameFamily"
                    onBlur={form.handleBlur}
                    onChange={form.handleChange}
                    value={form.values.personal.nameFamily ?? ''}
                />
            </FormGroup>
            <FormGroup
                isRequired={true}
                label={translate.common.email}
            >
                <TextInput
                    disabled={form.isSubmitting}
                    error={form.errors.getMessage('personal.emailAddress')}
                    name="personal.emailAddress"
                    onBlur={form.handleBlur}
                    onChange={form.handleChange}
                    value={form.values.personal.emailAddress ?? ''}
                />
            </FormGroup>
        </FormSection>
    );
}
